import React from 'react';
import { withRouter } from 'react-router';
import Navbar from '../Navbar/navbar.jsx';
import Navigation from '../Navigation/navigation.jsx';
import { isLogin } from '../../utils/authentication.js';
import { Form, Button, Table, ListGroup } from 'react-bootstrap';
import _ from 'lodash'
import Moment from "moment";
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import actions from '../../store/Actions/index.js';
import DemoUserForm from './DemoUserForm.js'


// let BACKEND_URL = 'http://localhost:3000'
let BACKEND_URL = 'https://api3.insightmonk.com'


class DemoUser extends React.PureComponent {
    state = {
        isOptionsLoadin: false,
        data: [],
        show: false,
        selectedData: null
    };

    componentWillMount() {

        if (!isLogin()) {
            this.props.history.push({
                pathname: "/login"
            });
        }

        this.setState({ isOptionsLoadin: true })
        this.getAllList()
    }

    getAllList() {
        axios.get(
            `${BACKEND_URL}/v1/explore/demousers`,
            {
                headers: {
                    token: localStorage.getItem("token")
                }
            }
        ).then((res) => {
            this.setState({ data: res.data })
            this.setState({ isOptionsLoadin: false })
        }).catch((err) => {
            this.setState({ isOptionsLoadin: false })
        })
    }


    onEditModal = (data) => {
        this.setState({ selectedData: data, show: true })
    }

    onEditClose = () => {
        this.setState({ selectedData: null, show: false })
    }


    handleSubmit = (data) => {
        console.log(data, ">>>")
        let conf = confirm("Are you sure you want to update?",data)
        if (conf && data) {
            axios.post(
                `${BACKEND_URL}/v1/explore/demousers`, data,
                {
                    headers: {
                        token: localStorage.getItem("token")
                    }
                }
            ).then((res) => {
                this.getAllList()
                this.setState({ isSaving: false, show: false })
                alert("Updated Successfully!")
            }).catch((err) => {
                this.setState({ isSaving: false, show: false })
            })
        }
    }

    onDelete = (id) => {
        let conf = confirm("Are you sure you want to delete " + id + " ?")
        if (conf && id) {
            axios.delete(
                `${BACKEND_URL}/v1/explore/demousers`, 
                {
                  headers: {
                    token: localStorage.getItem("token")
                  },
                  data: {
                     id: id
                  }
                }
            ).then((res) => {
                this.getAllList()
                alert("Deleted Successfully!")
            }).catch((err) => {
                console.log(err)
            })
        }

    }

    render() {
        const { isOptionsLoadin, data, selectedData } = this.state;

        return (
            <div>
                <div className="col-md-12 topbar">
                    <Navbar />
                </div>

                <main role="main" className="p-5">
                    <div className="my-3 p-3 bg-white rounded shadow-sm">
                        <h6 className="border-bottom border-gray pb-2 mb-0">BIS Workspace - Download disabled companies - {data && data.company_ids && data.company_ids.length}</h6>
                        <div className="card">

                            {!isOptionsLoadin && data && data.company_ids ?
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Company ID</th>
                                            <th><button type="button" className="btn btn-primary" onClick={() => this.onEditModal()}>Add new company to disable download</button></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!isOptionsLoadin && data && data.company_ids && data.company_ids.map((o, index) =>
                                            
                                            <tr key={index}>
                                                <td>{o}</td>
                                                <td>
                                                    <button type="button" className="btn btn-warning ml-2" onClick={() => this.onDelete(o)}>Delete</button>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table> :
                                <div className="p-1">Loading Please Wait....</div>
                            }


                            <Modal size="sm" show={this.state.show} onHide={this.onEditClose} className="modal-size">
                                <Modal.Header closeButton>
                                    <div className="row col-md-12">
                                        <Modal.Title className="col-md-12 heading-details">Add new company to disable download</Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body className="modal-body">
                                    <DemoUserForm initialValues={selectedData} onSubmit={this.handleSubmit} />
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}


export default withRouter(DemoUser);




// WEBPACK FOOTER //
// ./src/components/Insights/DemoUser.js